// extracted by mini-css-extract-plugin
module.exports = {"pageFooter":"PageFooter_pageFooter__12Mlq"};